import { render } from "./propertiesTakePhoto.vue?vue&type=template&id=0addfd47"
import script from "./propertiesTakePhoto.vue?vue&type=script&lang=js"
export * from "./propertiesTakePhoto.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__